import { IconButton } from '@components/iconButton/IconButton';
import { useServiceSearchParams } from './hooks/useServiceSearchParams';
import styles from './StatsButton.scss';

export const StatsButton = () => {
  const { openStatsDrawer } = useServiceSearchParams();

  return (
    <IconButton
      iconName="stats"
      ariaLabel="view stats"
      onClick={openStatsDrawer}
      className={styles.button}
      iconClassName={styles.icon}
      tooltipContent="View Service Stats"
      dataTooltipId="service-stats-tooltip"
      place="bottom"
    />
  );
};
